//import parse from 'parse-svg-path';
//import abs from 'abs-svg-path';
//import normalize from 'normalize-svg-path';
function isHTMLElement(o) {
  return (typeof HTMLElement === "object" ? o instanceof HTMLElement :
    o && typeof o === "object" && o !== null && o.nodeType === 1 && typeof o.nodeName === "string");
}
function isSVGElement(o) {
  return (typeof SVGElement === "object" ? o instanceof SVGElement :
    o && typeof o === "object" && o !== null && o.nodeType === 1 && typeof o.nodeName === "string");
}
export function stringToDom(htmlstring) {
  var div = document.createElement('div');
  div.innerHTML = htmlstring.trim();
  let childElements = [];
  div.childNodes.forEach((node) => {
    if (isSVGElement(node) || isHTMLElement(node)) {
      childElements.push(node);
    }
  });
  return childElements;
}
export function getPathsFromSVG(svg) {
  const svgDom = typeof svg === 'string' ? stringToDom(svg)[0] : svg;
  const paths = svgDom.getElementsByTagName('path');
  return Array.from(paths);
}
export function getCurvesFromSVGPaths(svg) {
  svg = '';
  return [svg];
}
function getInnerHeight(elm) {
  var computed = getComputedStyle(elm), padding = parseInt(computed.paddingTop) + parseInt(computed.paddingBottom);
  return elm.clientHeight - padding;
}
export function getSize(el) {
  let height = '24px';
  const elHeight = getStyle(el).height;
  const parentHeight = el.parentElement ? getInnerHeight(el.parentElement) : null;
  if (elHeight && elHeight !== 'auto' && elHeight !== '0px') {
    height = elHeight;
  }
  const isHeightAvailable = elHeight && (elHeight !== 'auto');
  if (!isHeightAvailable && parentHeight) {
    height = parentHeight + 'px';
  }
  return height;
}
export function getStyle(el) {
  const view = el.ownerDocument && el.ownerDocument.defaultView ?
    el.ownerDocument.defaultView : window;
  if (!view.getComputedStyle)
    return null;
  let style = view.getComputedStyle(el);
  return style;
}
